export const baseScalingPx = 10; //Rebrand 4
export const baseScaling = 0.4; //Rebrand 0.25

export const baseScalingPxRebrand = 16; //Rebrand 4
export const baseScalingRebrand = 0.25; //Rebrand 0.25

export const remToGapMultiplier = 2.5;

export const pxToRem = (px: number, flag?: boolean): string =>
    px === 0
        ? `${px}`
        : `${(px / (flag ? baseScalingPxRebrand : baseScalingPx)).toFixed(2)}rem`;

export const baseSpacing = (value: number, flag?: boolean): string =>
    value === 0
        ? `${value}`
        : `${(value * (flag ? baseScalingRebrand : baseScaling)).toFixed(3)}rem`;

export const remToRem = (rem: number): string =>
    rem === 0 ? `${rem}` : `${rem}rem`;

export type GridUnits = Rem | Px;
export type SpacingInput = GridUnits | number | 'auto' | string;

type Rem = { value: number; type: 'rem' };
type Px = { value: number; type: 'px' };

export const rem = (value: number): Rem => ({ value, type: 'rem' });
export const px = (value: number): Px => ({ value, type: 'px' });
// export const gridMultiplayer = (value: number) => value as GridMultiplayer;

const isRem = (value: GridUnits): value is Rem => {
    return 'type' in value && value['type'] === 'rem';
};

const isPx = (value: GridUnits): value is Px => {
    return 'type' in value && value['type'] === 'px';
};

const convertSize = (sizeToConvert: SpacingInput, isRebranding?: boolean) => {
    //auto
    if (typeof sizeToConvert === 'string') {
        return sizeToConvert;
    }

    if (typeof sizeToConvert === 'number') {
        return baseSpacing(sizeToConvert, isRebranding);
    }

    /* istanbul ignore else */
    if (isRem(sizeToConvert)) {
        return remToRem(sizeToConvert.value);
    }

    /* istanbul ignore else */
    if (isPx(sizeToConvert)) {
        return pxToRem(sizeToConvert.value, isRebranding);
    }

    /* istanbul ignore next */
    return 'auto';
};

export const spacingCreator =
    (isRebranding?: boolean) =>
    <T extends SpacingInput, R extends SpacingInput>(
        sizeToConvert: T | T[],
        newSizeToConvert?: R | R[],
    ): string => {
        const toConvert =
            isRebranding && newSizeToConvert !== undefined
                ? newSizeToConvert
                : sizeToConvert;

        const inputArray = Array.isArray(toConvert) ? toConvert : [toConvert];

        const sizeString = inputArray.reduce((accumulator, currentValue) => {
            return `${accumulator}${accumulator === '' ? '' : ' '}${convertSize(currentValue, isRebranding)}`;
        }, '');

        return sizeString;
    };

export const isRebrandingCreator =
    <T>(isRebrand?: boolean) =>
    (oldValue: T, newValue: T): T => {
        return isRebrand ? newValue : oldValue;
    };

/* istanbul ignore next */
export const getRebrandingColorCreator = (isRebrand?: boolean) =>
    isRebrandingCreator<string>(isRebrand);

/*
usage:
const size = theme.tggSpacing(([0, 'auto', rem(4), 'auto'], [0, 'auto', 1, 'auto']));
*/
